<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-03 10:03:54
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-14 18:21:51
 * @name: 确认收件
 * @Description: 确认收件
 * @FilePath: \project\src\views\index\afterSale\waitConfirmLogistics\waitConfirmLogistics.vue
 * @Author: desktop
-->
<template>
  <div class="waitConfirmLogistics">
    <div class="container">
      <div class="head">
        <el-button size="mini" type="primary" @click="back">返回</el-button>
      </div>
      <div class="content">
        <div class="card">
          <div class="title">
            <font>用户信息</font>
          </div>
          <div class="user-info">
            <div class="row">
              <font class="label">琴行名称：</font>
              <font class="value">{{ agency.agency_name }}</font>
            </div>
            <div class="row">
              <font class="label">琴行地址：</font>
              <font class="value">{{ agency.address }}</font>
            </div>
            <div class="row">
              <font class="label">联系电话：</font>
              <font class="value">{{ agency.mobile }}</font>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="title">
            <font>物流信息</font>
          </div>
          <div class="logistics-info">
            <div class="row">
              <font class="label">需寄回：</font>
              <div class="value">
                <font class="text">{{ send_back_items }}</font>
              </div>
            </div>
            <div class="row">
              <font class="label">运单号：</font>
              <div class="value">
                <div class="logisticsOrder">
                  <div class="logisticsOrder-title">
                    {{ company_name }} {{ express_no }}
                  </div>
                  <template v-if="showList.length > 0">
                    <div class="detail">
                      <div
                        class="item"
                        v-for="(item, index) of showList"
                        :key="index"
                      >
                        <div class="dot" v-if="index > 0"></div>
                        <div class="circle" v-else>
                          <img class="hook" src="@/assets/icon/hook.png" />
                        </div>
                        <div class="top">
                          <font>{{ item.status }}</font>
                          <font>{{ item.time }}</font>
                        </div>
                        <font class="des">{{ item.context }}</font>
                      </div>
                    </div>
                    <div class="clickbar" @click="showMore = !showMore">
                      <font v-if="!showMore">点击查看更多物流记录</font>
                      <font v-else>收起物流记录</font>
                      <img
                        src="@/assets/icon/arrow-left-red.png"
                        :class="{ open: showMore }"
                      />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-group" v-if="btn_group.length > 0">
          <div class="card">
            <template v-for="(item, index) in btn_group">
              <el-button
                :key="index"
                size="mini"
                :type="item.type === 'resolve' ? 'primary' : ''"
                @click="btnClickHandler(item, $route.query)"
                >{{ item.text }}</el-button
              >
            </template>
          </div>
        </div>
      </div>
    </div>
    <dialog-approve-normal
      ref="dialogApproveNormal"
      @finish="approveFinish()"
    ></dialog-approve-normal>
    <dialog-approve-xupinzhisp
      ref="dialogApproveXupinzhisp"
      @finish="approveFinish()"
    ></dialog-approve-xupinzhisp>
  </div>
</template>
<script>
import issueService from "@/module/issue/issue.service";
import { afterSale_detail_btn } from "@/config/afterSale.config.js";
import { getEventBus } from "@/config/eventBus.config.js";
import { debounceation } from "@/utils/decorator";
import dialogApproveNormal from "@/components/afterSale/dialog-approve-normal.vue";
import dialogApproveXupinzhisp from "@/components/afterSale/dialog-approve-xupinzhisp.vue";
export default {
  name: "indexWaitConfirmLogistics",
  components: {
    dialogApproveNormal,
    dialogApproveXupinzhisp,
  },
  data() {
    return {
      issueService: new issueService(),
      agency: {},
      send_back_items: "",
      company_name: "",
      express_no: "",
      list: [],
      showMore: false,
    };
  },
  computed: {
    showList() {
      let showList = [];
      if (this.showMore) {
        showList = this.list;
      } else {
        showList = this.list.filter((item, index) => index < 3);
      }
      return showList;
    },
    // 按钮组
    btn_group() {
      let btn_group = [];
      if (Number(this.$route.query.run_status) === 0) {
        btn_group =
          afterSale_detail_btn?.find((x) => x.key === this.$route.query.run_act)
            ?.btn ?? [];
      }
      return btn_group;
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    @debounceation(300)
    back() {
      this.$router.go(-1);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取信息
     */
    getInfo() {
      this.issueService
        .getVeifyQuality({
          issue_id: this.$route.query.issue_id,
          run_id: this.$route.query.run_id,
          run_process_id: this.$route.query.run_process_id,
        })
        .then((res) => {
          this.agency = res.data?.agency ?? {};
          this.send_back_items = res.data?.plan?.send_back_items ?? "";
          this.express_no = res.data?.content?.express_no ?? "";
          if (String(res.data?.content?.is_com) === "0") {
            this.company_name = res.data?.content?.com;
            this.list = [];
          } else {
            this.issueService
              .getCompanyName({ com: res.data?.content?.com ?? "" })
              .then((res2) => {
                this.company_name = res2.item;
                this.issueService
                  .getPackageInfo({
                    com: res2.items?.[res.data?.content?.com ?? ""]?.com ?? "",
                    num: res.data?.content?.express_no ?? "",
                  })
                  .then((res3) => {
                    this.list = res3.data.data;
                  });
              });
          }
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 按钮点击触发
     * @param {Object} item 点击的按钮数据
     * @param {Object} query 页面参数
     */
    @debounceation(300)
    btnClickHandler(item, query) {
      let req = {
        issue_id: query.issue_id,
        run_process_id: query.run_process_id,
      };
      if (String(item.value) === "-1") {
        this.$refs.dialogApproveNormal.open({ ...req, ...item });
      } else {
        switch (query.run_act) {
          case "shoudao":
            this.$refs.dialogApproveXupinzhisp.open(req);
            break;
          case "shoudaoend":
            this.$confirm(
              "确认用户已寄件，该操作无法挽回，你还要继续吗？",
              "确认用户已寄件",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.issueService.confirmParts(req).then((res) => {
                  this.approveFinish();
                });
              })
              .catch((err) => {});
            break;
        }
      }
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 审核结束
     */
    approveFinish() {
      this.$EventBus.$emit(getEventBus("我的售后列表发生变更"));
      this.$EventBus.$emit(getEventBus("待确认列表发生变更"));
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.waitConfirmLogistics {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .container {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    .head {
      margin-bottom: 10px;
      @extend .et-flex-start;
    }
    .content {
      width: 100%;
      @extend .et-flex-column-normal;
      .card {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0 !important;
        }
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-radius: $Vars-border-radius-normal;
        box-shadow: $Vars-boxShadow-normal;
        .title {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniTitle-size;
          font-weight: bold;
          border-bottom: 1px solid $Vars-border-second-color;
        }
        .user-info {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniContent-size;
          @extend .et-flex-normal;
          .row {
            flex: 1;
            margin-left: 10px;
            &:first-child {
              margin-left: 0 !important;
            }
            @extend .et-flex-normal;
            .label {
              flex-shrink: 0;
            }
            .value {
              flex: 1;
            }
          }
        }
        .logistics-info {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniContent-size;
          @extend .et-flex-column-normal;
          .row {
            width: 100%;
            margin-top: 10px;
            &:first-child {
              margin-top: 0 !important;
            }
            @extend .et-flex-normal;
            .label {
              flex-shrink: 0;
              margin-right: 20px;
            }
            .value {
              flex: 1;
              @extend .et-flex-column-normal;
              .logisticsOrder {
                width: 100%;
                box-sizing: border-box;
                background: white;
                @extend .et-flex-column-center;
                .logisticsOrder-title {
                  width: 100%;
                  padding-bottom: 10px;
                  font-size: $Vars-font-miniContent-size;
                  border-bottom: 1px solid $Vars-border-third-color;
                }
                .detail {
                  width: 100%;
                  box-sizing: border-box;
                  padding: 15px 12px 0;
                  @extend .et-flex-column-normal;
                  .item {
                    width: 100%;
                    &:not(:last-child) {
                      border-left: 1px solid $Vars-border-third-color;
                    }
                    &:last-child {
                      border-left: 1px solid white;
                    }
                    padding: 0 15px 20px;
                    @extend .et-flex-column-normal;
                    &:last-child {
                      padding-bottom: 0;
                    }
                    position: relative;
                    .dot {
                      position: absolute;
                      top: -5px;
                      left: -5px;
                      width: 8px;
                      height: 8px;
                      border-radius: 8px;
                      background: $Vars-font-placeholder-color;
                    }
                    .circle {
                      position: absolute;
                      top: -9px;
                      left: -9px;
                      width: 16px;
                      height: 16px;
                      border-radius: 16px;
                      box-sizing: border-box;
                      border: 1px solid #1296db;
                      background: white;
                      @extend .et-flex-center;
                      .hook {
                        width: 12px;
                        height: 12px;
                      }
                    }
                    .top {
                      margin-top: -9px;
                      width: 100%;
                      @extend .et-flex-start;
                      margin-bottom: 20px;
                      font {
                        &:nth-child(1) {
                          font-size: $Vars-font-miniTitle-size;
                          line-height: $Vars-font-none-lineHeight;
                          font-weight: 500;
                          color: $Vars-font-important-color;
                          margin-right: 12px;
                        }
                        &:nth-child(2) {
                          font-size: $Vars-font-miniTitle-size;
                          line-height: $Vars-font-none-lineHeight;
                          font-weight: 500;
                          color: $Vars-font-secondary-color;
                        }
                      }
                    }
                    .des {
                      margin-bottom: 5px;
                      font-size: $Vars-font-content-size;
                      font-weight: 500;
                      color: $Vars-font-placeholder-color;
                    }
                  }
                }
                .clickbar {
                  width: 100%;
                  padding: 15px 0;
                  @extend .et-flex-center;
                  @extend .et-clickElement;
                  font {
                    font-size: $Vars-font-content-size;
                    color: $Vars-font-secondary-color;
                    font-weight: 500;
                    margin-right: 13px;
                  }
                  img {
                    width: 9px;
                    height: 16px;
                    zoom: 0.8;
                    transform: rotate(270deg);
                    &.open {
                      transform: rotate(90deg) !important;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .btn-group {
        margin: 10px 0;
        width: 100%;
        .card {
          width: 100%;
          box-sizing: border-box;
          padding: 10px;
          border-radius: $Vars-border-radius-normal;
          box-shadow: $Vars-boxShadow-normal;
          @extend .et-flex-center;
        }
      }
    }
  }
}
</style>